import { Component } from '@angular/core';

@Component({
  selector: 'view-logo',
  templateUrl: 'logo.html'
})
export class LogoView {
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/views/logo/logo.ts